import styled from 'styled-components';

export const InclusionsContainer = styled.div`
  color: #4A4A4A;
  font-size: 18px;
  font-weight: 900;
  font-family: 'Lato';
  padding: 12px;
`;

export const InclusionHeading = styled.div`
  margin-top: 4px;
  padding-left: 4px;
`;

export const InfoListCard = styled.div`
  background-color: #fff;
  border-radius: 16px;
  padding: 12px;
  filter: drop-shadow(0px 0px 4px rgba(0, 0, 0, 0.20));
  display: flex;
  flex-direction: column;
  margin: 8px 4px 4px;
`;

export const ListItems = styled.ul`
  list-style: none;
`;

export const ListItem = styled.li`
  display: flex;
  align-items: top;

  &:not(:last-child) {
    margin-bottom: 12px;
  }
`;

export const Status = styled.img`
  height: 13px;
  width: 13px;
  border-radius: 50%;
  display: inline-block;
  position: relative;
  margin: 2px 4px 0px 0px;
`;

export const Label = styled.span`
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  font-family: 'Lato'
  color:#000;
`;

export const Separator = styled.div`
  height: 1px;
  background: #D8D8D8;
  margin: 16px 0px 12px;
`;

export const CtaSection = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const CtaLabel = styled.span`
  font-size: 14px;
  font-family: 'Lato';
  font-weight: 700;
  color: #008CFF;
`;

export const ArrowIcon = styled.img`
  height: 24px;
  width: 22px;
`;